import { IconAlertTriangleFilled } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';

export interface IBOEDiscrepancyIconProps {
    section: string;
    metricNames: string[];
    className?: string;
}

const BOEDiscrepancyIcon = ({ section, metricNames, className }: IBOEDiscrepancyIconProps) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const toggleTooltip = () => {
        setOpenTooltip(!openTooltip);
    };

    return (
        <div className={className}>
            <NSIcon
                id={`${section}-tooltip`}
                icon={IconAlertTriangleFilled}
                className="text-warning"
            />
            <Tooltip
                target={`${section}-tooltip`}
                isOpen={openTooltip}
                toggle={toggleTooltip}
                placement="top"
            >
                <strong>Discrepancies with Back-Of-Envelope</strong>
                <div>{metricNames.join(', ')}</div>
            </Tooltip>
        </div>
    );
};

export default BOEDiscrepancyIcon;
